import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "dataTable" }
const _hoisted_2 = {
  key: 1,
  class: "datatable-container"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoaderComponent = _resolveComponent("LoaderComponent")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isLoading && _ctx.caracteristiques.length === 0)
      ? (_openBlock(), _createBlock(_component_LoaderComponent, { key: 0 }))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_DataTable, {
            isLoading: _ctx.isLoading,
            "not-sticky": true,
            tableData: _ctx.caracteristiques,
            tableHeader: _ctx.tableHeader
          }, null, 8, ["isLoading", "tableData", "tableHeader"])
        ]))
  ]))
}